<script setup lang="ts">
import type { ObjectId } from '~/composables/charon'

const props = defineProps<{
  image?: ObjectId | null
  alt?: string
}>()

const placeholder = '/images/component/charonFile/news_placeholder.png'

const failed = ref(false)
const loaded = ref(false)

// falls back to the placeholder if there is no image or it could not be loaded
const picture = computed(() => props.image && !failed.value
  ? { src: `/charon/${props.image}`, alt: props.alt ?? '' }
  : { src: placeholder, alt: '' },
)

watch(() => props.image, () => {
  failed.value = false
})
watch(() => picture.value.src, () => {
  loaded.value = false
})
</script>

<template>
  <div class="relative w-full h-96 overflow-hidden rounded-t-md bg-gray-200">
    <slot
      v-if="!props.image && $slots.empty"
      name="empty"
    />
    <slot
      v-else-if="failed && $slots.error"
      name="error"
    />
    <template v-else>
      <NuxtPicture
        :src="picture.src"
        :alt="picture.alt"
        loading="eager"
        sizes="640px laptop:960px desktop:1078px"
        class="block h-full transition-opacity duration-500"
        :class="loaded ? 'opacity-100' : 'opacity-0'"
        :img-attrs="{
          class: 'object-cover object-center w-full h-full',
        }"
        @load="loaded = true"
        @error="failed = true"
      />
      <div
        v-if="!loaded"
        class="absolute inset-y-0 left-0 w-2/5 bg-gradient-to-r from-transparent via-white/60 to-transparent
          animate-shimmer motion-reduce:hidden"
      />
    </template>
  </div>
</template>
